
























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
// api
// icon图标
import { commonIcons, directivityIcons, solidIcons, foodIcons } from '@/utils/common-icons'
@Component({
  name: 'IconDialog',
  components: {
  }
})
export default class extends Vue {
  @Prop() private isVisible!: any
  private activeName= 'first'
  private el: any = this.$refs
  private isDisable =false
  private name=''
  private activeIndex=''
  private icon=''
  private listData =commonIcons
  private tabIndex = '0'
  // 功能函数
  // ui
  // 重置
  resetSearch() {
    // this.listData = commonIcons
    this.getData(this.tabIndex)
  }
  // 搜索
  handleSearch() {
  const icons = commonIcons.concat(directivityIcons, solidIcons, foodIcons)
  this.listData = icons.filter(
    item => item.indexOf(this.name) !== -1
  )
  }
  // 获取当前tab数据
  handleClick(val:any) {
    this.tabIndex = val.index
    this.getData(val.index)
  }
  getData(index:any) {
    if (index === '0') {
      this.listData = commonIcons
    } else if (index === '1') {
      this.listData = directivityIcons
    } else if (index === '2') {
      this.listData = solidIcons
    } else {
      this.listData = foodIcons
    }
  }
  // 选中图标
  hancleIcon(icon:string) {
    this.activeIndex = icon
    this.icon = icon
  }
  // 提交
  handleSubmit() {
    if (this.icon === '') {
      this.$message({
          message: '请选择图标',
          type: 'warning'
        })
        return
    }
    this.isDisable = true
    this.handleClose()
    this.$emit('getIcon', this.icon)
    setTimeout(() => {
      this.isDisable = false // 点击一次时隔两秒后才能再次点击
    }, 2000)
  }
  // 表单取消
  private handleClose() {
    this.activeIndex = ''
    this.name = ''
    this.getData(this.tabIndex)
    this.$emit('close')
  }
}
